import(/* webpackMode: "eager", webpackExports: ["PageTemplate"] */ "/vercel/path0/src/app/(main-layout)/featured/components/page-template.js");
